import { render, staticRenderFns } from "./SuccessNotification.vue?vue&type=template&id=2d31b580&scoped=true&"
import script from "./SuccessNotification.vue?vue&type=script&lang=js&"
export * from "./SuccessNotification.vue?vue&type=script&lang=js&"
import style0 from "./SuccessNotification.vue?vue&type=style&index=0&id=2d31b580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d31b580",
  null
  
)

export default component.exports